const plakaData = {
    plate: "",
    caseType: "",
    truckType: ""
}
export default plakaData